export default {"src":"/_next/static/media/lock-unlocked.f735de11.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};